import angular from "angular";

angular
    .module('ui-sentinel.relay')
    .controller('RelayAuditListController', RelayAuditListController);

/////////////

RelayAuditListController.$inject = ['$rootScope', '$timeout', '$stateParams', 'FeedbackService', 'ApiErrorService', 'RelayService'];

function RelayAuditListController($rootScope, $timeout, $stateParams, FeedbackService, ApiErrorService, RelayService) {
    const genericErrorMessage = "Unexpected error occurred while loading the relay audit trail";
    const permissionsErrorMessage = "Unable to load your relay permissions. Reload the page to try again.";

    // Typing settles for this long before the trail is re-queried, so a typed identifier costs one
    // or two queries rather than one per character.
    const filterDebounceMs = 300;

    const vm = {
        permissions: { canEdit: false, isEntitled: false },
        permissionsLoaded: false,

        list: null,
        filters: {
            // Prefilled when arriving from a relay badge on the device list.
            imei: $stateParams.imei || null,
            changedBy: null,
            from: null,
            to: null
        },
        page: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 100,
        errorMessage: null,
        filtering: false,
        feedback: FeedbackService,

        load: load,
        applyFilters: applyFilters,
        filtersChanged: filtersChanged,
        clearFilters: clearFilters,
        goToPage: goToPage,
    };

    // Declared before the return so the initializer runs.
    let filterTimer = null;
    let loadToken = 0;

    activate();
    return vm;

    function activate() {
        vm.feedback.clear();
        RelayService.permissions().then(
            function (permissions) {
                vm.permissions = permissions;
                vm.permissionsLoaded = true;
                if (permissions.isEntitled) {
                    load();
                }
            },
            function () {
                vm.errorMessage = permissionsErrorMessage;
            }
        );
    }

    // quiet keeps the full-screen loading overlay out of it. A filter refresh happens while the
    // user is still typing, and blanking the page for each one is worse than no feedback at all.
    function applyFilters(quiet) {
        vm.page = 1;
        load(quiet);
    }

    // Called as the text filters are typed into. The date filters commit a whole value at once, so
    // they call applyFilters directly and are not debounced.
    function filtersChanged() {
        if (filterTimer) {
            $timeout.cancel(filterTimer);
        }
        filterTimer = $timeout(function () { applyFilters(true); }, filterDebounceMs);
    }

    function clearFilters() {
        vm.filters = { imei: null, changedBy: null, from: null, to: null };
        applyFilters(true);
    }

    function goToPage(page) {
        vm.page = page;
        load();
    }

    function load(quiet) {
        if (quiet) {
            vm.filtering = true;
        } else {
            $rootScope.loading = true;
        }
        vm.errorMessage = null;

        // Typing can leave more than one load in flight. Each carries a token so a slower earlier
        // response cannot overwrite the results of a newer filter.
        const token = ++loadToken;
        const isCurrent = function () { return token === loadToken; };

        const countPromise = RelayService.countHistory(vm.filters, vm.itemsPerPage).$promise;
        countPromise.then(
            function (result) {
                if (!isCurrent()) {
                    return;
                }
                vm.totalPages = result.pageCount;
                vm.totalItems = result.itemCount;
            },
            function (error) {
                if (!isCurrent()) {
                    return;
                }
                vm.errorMessage = ApiErrorService.getMessage(error, genericErrorMessage);
            }
        );

        const listPromise = RelayService.listHistory(vm.filters, vm.page, vm.itemsPerPage).$promise;
        listPromise.then(
            function (result) {
                if (!isCurrent()) {
                    return;
                }
                vm.list = result;
            },
            function (error) {
                if (!isCurrent()) {
                    return;
                }
                vm.errorMessage = ApiErrorService.getMessage(error, genericErrorMessage);
            }
        ).finally(function () {
            // Only the newest load clears the indicator, or an early finish would hide that a
            // later one is still running.
            if (isCurrent()) {
                vm.filtering = false;
                $rootScope.loading = false;
            }
        });
    }
}
